import React from 'react';

const Signature = ({ data }) => {
  return (
    <div className="signature-section" style={{marginTop: '35px'}}>
      <div>Your Very Truly,</div>
      <div>{data.shipper.companyName}</div>
      <div style={{marginTop: '20px', position: 'relative'}}>
        Signed by <span className="signature-line"></span>
        <div style={{position: 'absolute', right: '0', top: '-15px'}}>
          {data.signedBy}
        </div>
      </div>
    </div>
  );
};

export default Signature;